import { makeModuleStateSelector } from "@client/content/selectors";
import { isModuleEntity } from "@client/lib/layout";
import { getInherittedSettingValue } from "@client/lib/settings";
import { entitiesSelector, screenSelector } from "@client/selectors";
import { createSelector } from "reselect";
import { defaultState, previewState } from "./reducer";
import { type CourseProgress } from "./types";

export const localStateSelector = makeModuleStateSelector<CourseProgress.AppState>(defaultState, previewState);

const makeCourseDetailModuleSelector = () => {
  return createSelector([entitiesSelector], (entities) =>
    Object.values(entities).find((x) => isModuleEntity(x) && x.moduleType === "CourseDetail")
  );
};

export const makeSectionIdsSelector = () => {
  const courseDetailModuleSelector = makeCourseDetailModuleSelector();

  return createSelector([courseDetailModuleSelector, screenSelector], (courseDetailModule, screen): string => {
    if (!courseDetailModule) return "";

    return getInherittedSettingValue(courseDetailModule.settings!, "", "sections", screen) ?? "";
  });
};
